<template>
  <div class="product-features">
    <introduce></introduce>
    <painPoint></painPoint>
    <ability></ability>
    <trial></trial>
  </div>
</template>

<script>
import introduce from './components/introduce.vue'
import painPoint from './components/painPoint.vue'
import ability from './components/ability.vue'
import trial from './components/trial.vue'

export default {
  name: 'productFeatures',
  components: {
    introduce,
    painPoint,
    ability,
    trial
  }
}
</script>

<style lang="scss" scoped>
.product-features {
}
@media (min-width: 750px) and (max-width: 960px) {
  .product-features {
  }
}
@media (min-width: 961px) {
  .product-features {
  }
}
</style>
